export function formatTitle(translated, title = "") {
  if (title) {
    return `${title} (${translated})`;
  }
  return `${translated}`;
}
